import React from 'react';
import Form from '@rjsf/core';
import { CustomTitleField } from './CustomTitleField';
import { CustomFieldTemplate } from './CustomFieldTemplate';
import WysiwygTemplate from './WysiwygTemplate';
import CollapsableArrayField from './CollapsableArrayField';
import InputPostCode from './InputPostCode';
import InputPhone from './InputPhone';
import InputSSN from './InputSSN';
import CustomDateField from './CustomDateField';

export const CustomForm = (props) => {
    const { 
        children,
        schema, 
        uiSchema, 
        formData,
        fields,
        showErrorList,
        onSubmit,
        widgets,
        validate,
        onChange
    } = props;

    const titleField = {
        TitleField: CustomTitleField
    };

    const customFields = fields ? {
        ...fields,
        ...titleField
    } : titleField;

    const defaultWidgets = {
        wysiwyg: WysiwygTemplate,
        formatZip: InputPostCode,
        formatPhone: InputPhone,
        formatSSN: InputSSN,
        customDate: CustomDateField
    };

    const customWidgets = widgets ? {
        ...widgets,
        ...defaultWidgets
    } : defaultWidgets;

    return (
        <Form
            schema={schema}
            uiSchema={uiSchema}
            FieldTemplate={CustomFieldTemplate}
            formData={formData}
            fields={customFields}
            showErrorList={showErrorList}
            onSubmit={onSubmit}
            widgets={customWidgets}
            ArrayFieldTemplate={CollapsableArrayField}
            validate={validate}
            onChange={onChange}
            transformErrors={errors => errors.filter(error => Object.prototype.hasOwnProperty.call(error, 'instance'))}
        >
            {children}
        </Form>
    );
};